export const isValidPersonName = (value = '') => {
  const PERSON_NAME_REGEXP = /^[a-zA-ZÀ-ü]{2,}(?: [a-zA-ZÀ-ü]{1,})*( [a-zA-ZÀ-ü]{2,})$/;

  return PERSON_NAME_REGEXP.test(value.trim());
};
